import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Navigation from './Navigation';

function Layout({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navigation />
      <Container component="main" sx={{ flex: 1, py: 3 }}>
        {children}
      </Container>
    </Box>
  );
}

export default Layout; 